import * as actions from 'actions/PaymentActions/PaymentActions';
import { AsyncStatus } from 'utils/asyncStatusHelper';
import get from 'lodash/get';
export const INITIAL_STATE = {
    asyncStatus: AsyncStatus.INIT,
    wallet_apps: [],
    preSelectedWalletId: ''
};
export default function mobileWalletBalance(state = INITIAL_STATE, action) {
    switch (action.type) {
        case actions.MOBILE_WALLET_OPTIONS_REQUEST:
        case actions.PAY_REQUEST:
            return Object.assign(Object.assign({}, state), { asyncStatus: AsyncStatus.LOADING, preSelectedWalletId: '', wallet_apps: [] });
        case actions.MOBILE_WALLET_OPTIONS_ERROR:
            return Object.assign(Object.assign(Object.assign({}, state), { asyncStatus: AsyncStatus.ERROR }), action.error);
        case actions.MOBILE_WALLET_OPTIONS_SUCCESS: {
            const walletApps = get(action, 'data.wallet_apps', []);
            const selectedWallet = walletApps.find((walletApp) => walletApp.selected);
            return Object.assign(Object.assign(Object.assign(Object.assign({}, state), { asyncStatus: AsyncStatus.SUCCESS }), action.data), { preSelectedWalletId: selectedWallet && selectedWallet.app_code });
        }
        default:
            return state;
    }
}
